export enum RingStyleEnum {
  Heritage = 'heritage',
  Horizon = 'horizon',
  OuraRing4 = 'oura-ring-4',
  Ceramic = 'oura-ring-4-ceramic',
}
